export const GET_PRODUCT_LIST = "getProductList"